export default __webpack_public_path__ + "static/media/resume-me.ec44c02a.pdf";